import { Route , Routes, useLocation } from "react-router-dom";
import { Fragment, lazy, Suspense, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loader from "./components/Loader";

const Index = lazy(() => import("./Pages/Index"));
const Gallery = lazy(() => import("./Pages/Gallery"));
const Aboutus = lazy(() => import("./Pages/Aboutus"));
const Contact = lazy(() => import("./Pages/Contact"));
const NewArrival = lazy(() => import("./Pages/NewArrival"));
const Sculpture = lazy(() => import("./Pages/Sculpture"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
      <Fragment>
        <ScrollToTop />
        <Navbar/>
    <main>
      <Suspense fallback={
        <div className="flex flex-col justify-center items-center h-screen bg-bgDark space-y-4">
          <span className="text-[11px] tracking-[0.3em] animate-pulse text-zinc-400 uppercase font-light">
            Suresh Gosavi
          </span>
          <div className="w-12 h-[1px] bg-zinc-900 relative overflow-hidden">
            <div 
              className="absolute left-0 top-0 h-full w-full bg-accent" 
              style={{ animation: "loadingLine 1.5s infinite linear" }}
            ></div>
          </div>
        </div>
      }>
      <Routes>
      <Route path="/" element={<Index />}/>
      <Route path="/newarrival" exact element={<NewArrival />}/>
      <Route path="/Gallery" exact element={<Gallery />}/>
      <Route path="/aboutus" exact element={<Aboutus />}/>
      <Route path="/contact" exact element={<Contact />}/>
      <Route path="/sculpture" exact element={<Sculpture />}/>
      </Routes>
      </Suspense>
      </main>
      <footer>
        <Footer/>
      </footer>
      </Fragment>
  );
}

export default App;
